import { render, staticRenderFns } from "./AddDayCare.vue?vue&type=template&id=32593a53&"
import script from "./AddDayCare.vue?vue&type=script&lang=js&"
export * from "./AddDayCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports